/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type BookingFilterQuickFilter = typeof BookingFilterQuickFilter[keyof typeof BookingFilterQuickFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingFilterQuickFilter = {
  active_upcoming: 'active_upcoming',
  past: 'past',
  others: 'others',
  all: 'all',
} as const;
